import styled from "styled-components";
import InnerMarkdownHTML from "../../../../../base/text/inner-markdown-HTML/index.js";
import { BoxShadowWithHover } from "../../../../../../styles/common/mixins/box-shadow.styled.js";
import { FlexMixin, FontMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
import { BorderRadius } from "../../../../../../styles/common/mixins/logical.styled.js";
export const CardSimpleWrapperDesktop = styled.div.withConfig({
    displayName: "styled__CardSimpleWrapperDesktop",
    componentId: "sc-6e61ac4e-0"
})`
	${BorderRadius({
    all: '4px'
})}
	${BoxShadowWithHover}
	overflow: hidden;
	position: relative;
	transition: all 0.2s cubic-bezier(0.25, 0.8, 0.25, 0.1);
	width: 100%;

	& > figure > img {
		${({ $height ='250'  })=>`height:${$height}px`};
		object-fit: cover;
		width: 100%;
	}
`;
export const CardSimpleContentDesktop = styled.a.withConfig({
    displayName: "styled__CardSimpleContentDesktop",
    componentId: "sc-6e61ac4e-1"
})`
	${BorderRadius({
    all: '4px'
})}
	${FlexMixin({
    align: 'center',
    direction: 'column',
    justify: 'center'
})}
	background-color: ${({ theme  })=>theme.colors.black.low};
	bottom: 0;
	left: 0;
	padding: 12px;
	position: absolute;
	right: 0;
	top: 0;
`;
export const CardSimpleTitleDesktop = styled(InnerMarkdownHTML).withConfig({
    displayName: "styled__CardSimpleTitleDesktop",
    componentId: "sc-6e61ac4e-2"
})`
	${FontMixin({
    size: 'large',
    weight: 'medium',
    height: 'large'
})}
	color: ${({ theme  })=>theme.colors.white.base};
	margin: 0;
	text-align: center;
	text-transform: uppercase;
	padding: 8px 12px;
	border: 1px solid ${({ theme  })=>theme.colors.white.base};
	border-radius: 4px;
	margin-bottom: 8px;
`;
export const CardSimpleSubtitleDesktop = styled(InnerMarkdownHTML).withConfig({
    displayName: "styled__CardSimpleSubtitleDesktop",
    componentId: "sc-6e61ac4e-3"
})`
	${FontMixin({
    size: 'base',
    weight: 'regular',
    height: 'medium'
})}
	color: ${({ theme  })=>theme.colors.white.base};
	margin: 0;
	padding: 8px 0;
	text-align: center;
`;
export const CardSimpleFromDesktop = styled.span.withConfig({
    displayName: "styled__CardSimpleFromDesktop",
    componentId: "sc-6e61ac4e-4"
})`
	${FontMixin({
    size: 'medium',
    weight: 'regular',
    height: 'small'
})}
	color: ${({ theme  })=>theme.colors.white.base};
`;
export const CardSimplePriceDesktop = styled.div.withConfig({
    displayName: "styled__CardSimplePriceDesktop",
    componentId: "sc-6e61ac4e-5"
})`
	& > .price {
		${FontMixin({
    size: 'largest',
    weight: 'medium',
    height: 'largest'
})}
		color: ${({ theme  })=>theme.colors.white.base};
		margin: 0;
	}

	& > .currency {
		${FontMixin({
    size: 'larger',
    weight: 'medium',
    height: 'medium'
})}
		color: ${({ theme  })=>theme.colors.white.base};
		margin: 0;
	}
`;

//# sourceMappingURL=styled.js.map